"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadData = exports.getAppIdentity = void 0;
const tslib_1 = require("tslib");
const wix_experiments_1 = tslib_1.__importDefault(require("@wix/wix-experiments"));
const InteractionName_1 = require("../types/InteractionName");
const getAppIdentity = (props) => ({
    appDefId: props.meta.appDefId,
    appInstanceId: props.meta.appInstanceId,
    auth: {
        appInstance: props.meta.appInstance,
        revalidateAppInstance: props.revalidateAppInstance,
    },
});
exports.getAppIdentity = getAppIdentity;
const preloadData = (props, fedopsLogger) => {
    fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadExperiments);
    const experiments = new wix_experiments_1.default({
        useNewApi: true,
        scopes: ['payments', 'payments-checkout'],
        requestContext: {
            forSiteVisitors: {
                visitorId: props.meta.visitorId,
                siteOwnerId: props.meta.siteOwnerId,
            },
        },
        onError(error) {
            console.error('[express-widget] Error in loading experiments:', error);
        },
    });
    return {
        experiments,
    };
};
exports.preloadData = preloadData;
//# sourceMappingURL=preloadData.js.map